<template>
  <b-container fluid>
    <b-row>
      <b-col class="px-0">
        <div class="logo-wrapper">
          <img
            height="52"
            alt="lab-vet-logo"
            src="../assets/logo.png"
            class="mx-5 my-3"
          >
        </div>
      </b-col>
    </b-row>
  </b-container>
  <!--  <div id="bg">-->
  <!--    <div id="header-box">-->
  <!--      <div id="box">-->
  <!--&lt;!&ndash;        <div id="text">&ndash;&gt;-->
  <!--&lt;!&ndash;          {{ header }}&ndash;&gt;-->
  <!--&lt;!&ndash;        </div>&ndash;&gt;-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->
</template>

<script>
  export default {
    props: {
      header: {
        default: "LAB VET AND VITRO",
        type: String
      }
    }
  };
</script>

<style lang="scss" scoped>
  .logo-wrapper {
    position: relative;
    text-align: left;
    background-color: #C4C4C4;


    &::after {
      background-image: url('../assets/logo-background.png') !important;
      content: "" !important;
      display: block !important;
      position: absolute !important;
      width: 100% !important;
      height: 100% !important;
      background-size: cover !important;
      background-position-y: 99% !important;
      opacity: 0.2 !important;
      z-index: 1 !important;
      top: 0;
    }
  }
  #bg {
    background-color: #c4c4c4;

    height: 10vh;
    display: flex;
    justify-content: flex-end;
  }
  #header-box {
    height: 10vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  #box {
    display: flex;
    flex-direction: column;
    height: 70%;
    width: 30vw;
    justify-content: center;
    background-color: #6e6d6d;
  }
  #text {
    font-size: 2.2vw;
    text-align: right;
    color: white;
    margin-right: 3vh;
  }
</style>
